
document.addEventListener('DOMContentLoaded', () => {
   
     const tabs = document.querySelectorAll('.liv-main-search__tab');
     const contents = document.querySelectorAll('.liv-main-search__tab-content');
   
     tabs.forEach((tab) => {
   
       tab.addEventListener('click', () => {
   
         const target = tab.dataset.tab;
   
         tabs.forEach((item) => {
           item.classList.remove('is-active');
         });
   
         contents.forEach((content) => {
           content.classList.remove('is-active');
         });
   
         tab.classList.add('is-active');
   
         const activeContent = document.getElementById(`tab-${target}`);
   
         if (activeContent) {
           activeContent.classList.add('is-active');
         }
   
       });
   
     });
   
   });
